(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    var TZ_FALLBACK = "Europe/Copenhagen";

    function tzOffsetMs(date, timeZone) {
      var dtf = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
      var parts = dtf.formatToParts(date).reduce(function (acc, p) {
        acc[p.type] = p.value;
        return acc;
      }, {});
      var asUTC = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour),
        Number(parts.minute),
        Number(parts.second)
      );
      return asUTC - date.getTime();
    }

    function wallTimeToUtcMs(y, m, d, h, min, s, timeZone) {
      var naiveUTC = new Date(Date.UTC(y, m - 1, d, h, min, s));
      return naiveUTC.getTime() - tzOffsetMs(naiveUTC, timeZone);
    }

    function pad2(value) {
      return String(value).padStart(2, "0");
    }

    function initCountdown(root) {
      if (!root || root.dataset.countdownReady === "true") return;
      root.dataset.countdownReady = "true";

      var timeZone = root.dataset.timezone || TZ_FALLBACK;
      var targetUtcMs = wallTimeToUtcMs(
        Number(root.dataset.year),
        Number(root.dataset.month),
        Number(root.dataset.day),
        Number(root.dataset.hour),
        Number(root.dataset.minute),
        Number(root.dataset.second),
        timeZone
      );

      var serverNowMs = Number(root.dataset.serverNow) * 1000;
      var startPerf = typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();

      function getNowMs() {
        var t = typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();
        return serverNowMs + (t - startPerf);
      }

      var daysEl = root.querySelector('[data-unit="days"]');
      var hoursEl = root.querySelector('[data-unit="hours"]');
      var minsEl = root.querySelector('[data-unit="minutes"]');
      var secsEl = root.querySelector('[data-unit="seconds"]');
      var expiredEl = root.querySelector("[data-countdown-expired]");
      var hideExpired = root.dataset.hideExpired === "true";
      var designMode = root.dataset.designMode === "true";

      function setExpired() {
        if (daysEl) daysEl.textContent = "0";
        if (hoursEl) hoursEl.textContent = "00";
        if (minsEl) minsEl.textContent = "00";
        if (secsEl) secsEl.textContent = "00";

        if (expiredEl) {
          expiredEl.hidden = false;
          root.classList.add("is-expired");
        }

        if (hideExpired && !designMode) {
          root.style.display = "none";
        }
      }

      function updateCountdown() {
        var distance = targetUtcMs - getNowMs();

        if (distance <= 0) {
          setExpired();
          clearInterval(root._countdownInterval);
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = String(days);
        if (hoursEl) hoursEl.textContent = pad2(hours);
        if (minsEl) minsEl.textContent = pad2(minutes);
        if (secsEl) secsEl.textContent = pad2(seconds);
      }

      updateCountdown();
      root._countdownInterval = setInterval(updateCountdown, 1000);
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll("[data-countdown-timer-root]").forEach(initCountdown);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener("shopify:section:load", function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
